import React from 'react';

import {
  Typography,
  Grid,
} from '@material-ui/core';

import { SHAADIYOG_HOST } from '../../config/constants';
import satishbhai from '../../assets/img/Satish_Vithalani.jpg';
import rashmiben from '../../assets/img/rashmiben.jpg';
import ambrishbhai from '../../assets/img/Ambrishbhai.jpg';
import vinodbhimjyani from '../../assets/img/vinodbhimjyani.jpg';
import jayendrabhai from '../../assets/img/jayendrabhai.jpg';
import {themeColors} from "../../util";



const getContent1 = (content = 'anjal') => {
  if (content === 'sy') {
    return (
      <Typography variant="subheading">
        {'Name - Late Shri Bhawanishankarji Khemka'}<br />
        {'Description - (28th April 1945 - 17th August 2009)'}
        <br /><br />
        {'Spent his childhood in Rangoon then shifted to Rantangarh, Rajasthan.'}
        {'His father Late Shri Dharamchandji Khemka left for his heavenly abode when Late Shri Bhawanishankarji Khemka had to take the responsibility and start the work of intracity trading at 11 years of age. He always had an attitude of "Never say die and keep working".'}
      </Typography>
    );
  }
  return (
    <Typography variant="subheading" style={{textAlign: 'justify'}}>
      <b>Shree Lohana Mahaparishad Organization Matrimony Committee</b><br/>
      Shree Lohana Mahaparishad is the Matrusanstha or mother institution of Lohana community members all over the world. It is the apex federal body of Lohana Mahajans and organizations in India and overseas. Members of the Gujarati Lohana community are called Raghuvanshis, believed to be descendents of Lord Shri Ram, currently estimated to be around 3.5 million.
      <br/>
    </Typography>
  );
};


const getContent2 = (content = 'anjal') => {
  if (content === 'sy') {
    return (
      <React.Fragment>
        <Typography variant="subheading">
          {'Before settling in Mumbai in 1971, he did several businesses. He always had a keen interetest towards social service and working towards the betterment of the Marwari community.'}
        </Typography>
        <Typography variant="subheading" style={{ marginTop: '10px' }}>
          {'He gave us the slogan "Don\'t worry about the problem, find a solution and keep going". We all at Khemka family are excelling following principles and values he laid down on us. His blessings are always there with us...'}
        </Typography>
      </React.Fragment>
    );
  }
  return (
    <React.Fragment>
      <Typography variant="subheading" style={{textAlign: 'justify'}}>
        Shree Lohana Mahaparishad under the dynamic leadership of the present President Shri Satishbhai Vithalani, appointed Shri Ambrishbhai Sodha & Shri Jayendrabhai Sodha as President and Shri Vinod Bhimjyani as Vice President of the Organization’s Matrimony Committee. They are well experienced as matrimony counselors as well as have operating abilities to actively handle matrimonial   organization on large scale for more then 25 years.
      </Typography>
      <Typography variant="subheading" style={{textAlign: 'justify', marginTop: '6px'}}>
        The Matrimony committee after appointment, accepted a challenge and decided to incorporate/setup proper infrastructure like Matrimonial Website and Zone wise talented /experienced Team to handle Registration of Prospective candidates , conduct Match making seminars , organize counselling  webinars to educate not only candidates but thire parents to find suitable bride/grooms for their sons & daughter.
      </Typography>
      <Typography variant="subheading" style={{textAlign: 'justify', marginTop: '6px'}}>
        Matrimonial Website www.lmplagnasetu.com is developed a corporate level distributed network branches website which will be given to all Zones & Regions to independently input prospective candidates matrimonial profiles/data from their local area and register their membership.
      </Typography>
      <Typography variant="subheading" style={{textAlign: 'justify', marginTop: '6px'}}>
        Secondly they appointed experienced/talented Team members in each and every zones/regions of the world over to support/handle all matrimonial activates and serve Lohana community people for their needs of matrimony services in their zones/regions.
      </Typography>
    </React.Fragment>
  );
};


const aboutUs = () => {
  document.title = 'About Us';
  return (
    <React.Fragment>
      {window.location.host === SHAADIYOG_HOST && (
      <Grid container spacing={8}>
        <Grid item md={2} sm={4}>
          <img alt="about" src={satishbhai} style={{ width: '100%', border: 'thin solid #666' }} />
        </Grid>
        <Grid item md={10} sm={8}>
          {getContent1('sy')}
        </Grid>
        <Grid item md={12}>
          {getContent2('sy')}
        </Grid>
      </Grid>
      )}
      {window.location.host === SHAADIYOG_HOST && (
        <React.Fragment>
          <br />
          <Typography variant="headline">
        About Anjal ane Avsar
          </Typography>
          <br />
        </React.Fragment>
      )}
      <Grid container spacing={8}>

        <Grid item md={12}>
          {getContent1()}
        </Grid>
        <Grid item md={12}>
          {getContent2()}
        </Grid>
      </Grid>

      <Grid container spacing={8}>
        <Grid item md={12} sm={12} xs={12} style={{textAlign: 'center', margin:'10px 0px'}}>
          <Typography variant="h5" style={{color:themeColors[window.location.host].primaryDark}}><b>Shree Lohana Mahaparishad</b></Typography>
        </Grid>
      </Grid>

      <Grid container spacing={8} style={{display: 'flex',justifyContent:'center'}}>
        <Grid item md={4} sm={4} xs={12} style={{textAlign: 'center'}}>
          <img alt="Shri Satishbhai Vithalani" src={satishbhai} style={{ width: '70%', border: 'thin solid #666', marginTop: '10px' }} className={"profilePic"} />
          <Typography variant="subheading" style={{textAlign: 'center'}}><b>Shri Satishbhai Vithalani</b></Typography>
          <Typography style={{textAlign: 'center', fontSize:'13px'}}>LMP President and Managing Trustee</Typography>
        </Grid>
        <Grid item md={4} sm={4} xs={12} style={{textAlign: 'center'}}>
          <img alt="Shri Rashmiben S. Vithalani" src={rashmiben} style={{ width: '70%', border: 'thin solid #666', marginTop: '10px' }} className={"profilePic"} />
          <Typography variant="subheading" style={{textAlign: 'center'}}><b>Shrimati Rashmiben S. Vithalani</b></Typography>
          <Typography style={{textAlign: 'center', fontSize:'13px'}}>LMP Trustee and Women's Wing President</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={8}>
        <Grid item md={12} sm={12} xs={12} style={{textAlign: 'center', margin:'10px 0px'}}>
          <Typography variant="h5" style={{color:themeColors[window.location.host].primaryDark,}}><b>Matrimonial Committee</b></Typography>
        </Grid>
      </Grid>

      <Grid container spacing={8}>
        <Grid item md={4} sm={4} xs={12} style={{textAlign: 'center'}}>
          <img alt="Shri Ambrishbhai Sodha" src={ambrishbhai} style={{ width: '70%', border: 'thin solid #666', marginTop: '10px' }} className={"profilePic"} />
          <Typography variant="subheading" style={{textAlign: 'center'}}><b>Shri Ambarishbhai Sodha</b></Typography>
          <Typography style={{textAlign: 'center', fontSize:'13px'}}>LMP Matrimonial Committee Chairman</Typography>
        </Grid>
        <Grid item md={4} sm={4} xs={12} style={{textAlign: 'center'}}>
          <img alt="Shri Jayendrabhai Sodha" src={jayendrabhai} style={{ width: '70%', border: 'thin solid #666', marginTop: '10px'}} className={"profilePic"} />
          <Typography variant="subheading" style={{textAlign: 'center'}}><b>Shri Jayendrabhai Sodha</b></Typography>
          <Typography style={{textAlign: 'center', fontSize:'13px'}}>LMP Matrimonial Committee Chairman</Typography>
        </Grid>
        <Grid item md={4} sm={4} xs={12} style={{textAlign: 'center'}}>
          <img alt="Shri Vinod Bhimjyani" src={vinodbhimjyani} style={{ width: '70%', border: 'thin solid #666', marginTop: '10px' }} className={"profilePic"} />
          <Typography variant="subheading" style={{textAlign: 'center'}}><b>Late Shri Vinod Bhimjyani</b></Typography>
          <Typography style={{textAlign: 'center', fontSize:'13px'}}>LMP Lagna Setu Portal Convener</Typography>
        </Grid>
      </Grid>
      <Grid container spacing={8}>
        <Grid item md={12}>
          <Typography variant="subheading">
            {/* Disclaimer: <br />
            We at Lohana Mahaparishad Matrimony Committee members and our team do not accept any responsibility for the correctness of the profile data put in by each and every candidates themselves in our website. */}
          </Typography>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};


export default aboutUs;



// WEBPACK FOOTER //
// ./src/main/components/AboutUs.js